import ImageViewModal from './ImageViewModal';

export default ImageViewModal;
